<template>
  <v-app>
    <v-container
      fluid
      tag="section"
      class="pt-0"
    >
      <v-row justify="center">
        <v-col
          cols="12 px-6"
        >
          <v-row>
            <v-col
              class="py-0  d-flex justify-center"
              offset-sm="4"
              sm="4"
            >
              <v-img
                contain
                height="80pt"
                width="100pt"
                :src="'data:image/jpg;base64,'+configuration.interface_description.first_screen.logo_base64"
              />
            </v-col>
          </v-row>
          <v-card
            flat
            height="12rem"
            class="d-flex align-center justify-center"
          >
            <v-icon
              size="8rem"
              color="green"
            >
              mdi-check-circle-outline
            </v-icon>
          </v-card>
          <v-row>
            <v-col
              cols="12"
              class="text-center payment-message pa-1"
            >
              Оплата успешна
            </v-col>
            <v-col class="text-center payment-message2 pa-1">
              {{ Number(this.order.sumFull).money() }}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="email"
                dense
                hide-details
                outlined
                label="Введите свой e-mail"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn
                width="100%"
                depressed
                @click="onSendCheque"
              >
                Отправить чек
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              v-if="showMessage"
              cols="12"
              class="text-center py-1"
            >
              {{ this.message }}
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="9"
              sm="5"
              md="3"
              class="pr-1 text-start payment-text3"
            >
              Чек платежа
            </v-col>
            <v-col
              cols="2"
              sm="1"
              class="payment-text-start pa-1"
            >
              <v-btn
                depressed
                fab
                small
                @click="onShowDialog"
              >
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-dialog
        v-model="dialogVisible"
        fullscreen
      >
        <v-card>
          <v-toolbar
            flat
            dense
          >
            <v-btn
              icon
              @click="dialogVisible=false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <!--            <v-toolbar-title>Реквизиты платежа</v-toolbar-title>-->
          </v-toolbar>
          <v-card-text class="px-1 pb-1">
            <div v-html="cheque" />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>

<style scoped>
.payment-message {
  font-size: 1.5rem;
  font-weight: 400;
}
.payment-message2 {
  font-size: 2rem;
  font-weight: 700;
}
</style>
<script>
import { JustpayQrPaymentService } from "@/views/loyalty/shared/services/justpay-qrpayment-service"
import { JustpayOrderModel } from "@/views/loyalty/models/justpay-order.model"
import { JustpayPaymentSystemService } from "@/views/loyalty/shared/services/justpay-paymentsystem-service"
import { PaymentService } from "@/views/loyalty/shared/services/payment-service"

export default {
  data: () => ({
    cheque: '',
    configuration: {},
    dialogVisible: false,
    email: null,
    message: '',
    order: new JustpayOrderModel(),
    paymentSystemService: null,
    pointId: null,
    showMessage: false
  }),
  async beforeMount () {
    const orderNumber = this.$route.query.reference
    this.paymentSystemService = new JustpayPaymentSystemService()
    this.justpayQrPaymentService = new JustpayQrPaymentService()
    const order = await this.justpayQrPaymentService.getOrderByNumber(orderNumber)
    this.order = new JustpayOrderModel(order)
    console.log('this.order', this.order)

    const response = await this.paymentSystemService.getEntities(this.order.pointId)
    console.log('response', response)
    if (!response.value.error) {
      console.log('Success!')
      this.configuration = response.value.data.configuration
      // this.nomenclatures = response.value.data.nomenclatures
    }
    this.cheque = await this.justpayQrPaymentService.getCheque(this.order.orderId)
  },
  async mounted () {

  },
  methods: {
    async onSendCheque () {
      if (this.email) {
        this.message = await this.justpayQrPaymentService.sendCheque(this.order.orderId, this.email)
        this.showMessage = true
        setTimeout(() => { this.showMessage = false }, 5000)
      }
    },
    onShowDialog () {
      this.dialogVisible = true
    },
  }
}
</script>
